"use client";

import React, { use, useEffect, useRef, useState } from "react";
import { Image } from "@crystallize/reactjs-components";
import { RichTextRenderer } from "~/ui/components/rich-text-renderer";

interface CategoryHeroProps {
  title: string;
  intro?: any; // Replace with the exact type for `intro.json` if available
  thumbnail?: {
    images: {
      url: string;
      variants: any[];
      altText: string;
    }[];
  };
}

const CategoryHero: React.FC<CategoryHeroProps> = ({
  title,
  intro,
  thumbnail,
}) => {
  const [showMore, setShowMore] = useState(false);
  const [showShowMore, setShowShowMore] = useState(false);

  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === contentRef.current) {
          const height = entry.contentRect.height;
          setShowShowMore(height > 380);
        }
      }
    });

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="cat-banner">
      <div className="container 2xl px-5 mx-auto w-full md:flex justify-between">
        <div
          className={`cat-banner__text md:basis-4/6 lg:basis-3/6 ${!showMore && showShowMore ? "cat-banner__text--shaded" : ""}`}
        >
          <div className="cat-banner__text__content">
            <div className="cat-banner__text__content__span" ref={contentRef}>
              <h1 className="mt-3 lg:mt-6 mb-4">{title}</h1>
              {intro && <RichTextRenderer json={intro} />}
            </div>
          </div>
          {showShowMore && intro && (
            <div className={`read-more-wrapper`} style={{ bottom: -30 }}>
              <button
                className="read-more-toggle text-black"
                onClick={() => setShowMore(!showMore)}
              >
                {!showMore ? <span>Vis mer</span> : <span>Vis mindre</span>}
              </button>
            </div>
          )}
        </div>
        {thumbnail && (
          <div className="cat-banner__image md:basis-1/3 hidden md:flex">
            <Image
              width={300}
              height={400}
              url={thumbnail.images[0].url}
              variants={thumbnail.images[0].variants}
              sizes="300px"
              alt={thumbnail.images[0].altText}
              loading="eager"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryHero;
